import { withStyles } from '@material-ui/core/styles';
import { Slider } from '@material-ui/core';

const CostTrackingIndicator = withStyles(theme => ({
  root: {
    color: theme.palette.success.main,
  },
  thumb: {
    display: 'none',
  },
  active: {
    backgroundColor: 'red',
  },
  valueLabel: {
    left: 'calc(-50% + 40px)',
  },
  track: {
    height: theme.spacing(2),
    borderRadius: 4,
  },
  rail: {
    height: theme.spacing(2),
    borderRadius: 4,
  },
  markLabel: {
    top: theme.spacing(5),
  },
  mark: {
    opacity: 0,
  },
}))(Slider);

export default CostTrackingIndicator;
